<div *ngIf="show" class="c-modal c-modal-in" tabindex="-1" role="dialog" style="display: block; opacity: 1;" (click)="onBackdropClick($event)">
  <div #modalDialog class="c-modal-dialog" role="document" (click)="$event.stopPropagation()">
    <div class="c-modal-content">
      <div class="c-modal-header">
        <h2 class="c-modal-title">Notice</h2>
      </div>
      <div class="c-modal-body">
       This site may contain areas and content classified as Internal, Confidential, or Restricted. Unauthorized access or use is prohibited and may be monitored and reported. By continuing, you agree to comply with our Terms, Acceptable Use, and Security Policies.
      </div>
      <div class="c-modal-footer c-modal-footer-center">
        <button type="button" class="c-btn c-btn-lg c-btn-primary" (click)="onClose()">Close</button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="show" class="c-modal-backdrop c-modal-in" style="opacity: 0.5;" (click)="onClose()"></div>
